<template>
  <div>
    <ConferenceDiagnosisComp v-bind:mobile="mobile"/>
    <RedirectEnterpriseComp v-bind:mobile="mobile"/>
  </div>
</template>

<script>
import ConferenceDiagnosisComp from '@/components/desktop/Enterprise/ConferenceDiagnosisComp'
import RedirectEnterpriseComp from '@/components/desktop/Enterprise/RedirectEnterpriseComp'

  export default {
    name: 'ConferenceDiagnosis',
    props: ['mobile'],
    components: {
      ConferenceDiagnosisComp,
      RedirectEnterpriseComp
    },
  }
</script>
